<template>
  <div class="py-10 md:py-20 px-4 md:px-0 bg-semantic-surface-container-lowest">
    <!-- eslint-disable vue/no-v-html -->
    <div class="max-w-wrapper-lg mx-auto">
      <div v-if="badgeTitle || title || description" class="flex flex-col md:gap-4 gap-2 justify-center items-center">
        <V2AtomsLabel v-if="badgeTitle">
          {{ badgeTitle }}
        </V2AtomsLabel>
        <p
          v-if="title"
          ref="title"
          class="text-2xl/[120%] text-center md:text-4xl/[120%] text-semantic-surface-on-surface font-bold"
          v-html="title"
        />
        <p
          v-if="description"
          ref="description"
          class="text-base/[150%] text-center md:text-lg/[150%] text-semantic-surface-on-surface"
          v-html="description"
        />
      </div>

      <ClientOnly>
        <div
          v-if="list.length"
          class="drop-shadow-sm-2 grid grid-col-1 md:grid-cols-2 items-start md:gap-8 gap-4 md:mt-10 mt-6"
        >
          <V2MoleculesCardHorizontalCard
            v-for="(item, itemKey) in list"
            :key="itemKey"
            :image-path="item.imagePath"
            :title="item.title"
            fill-height
            wrapper-class="border-semantic-util-transparent"
            image-class="h-40"
            :description="item.description"
            :cta-btn-to="item.ctaBtnTo"
            :cta-btn-label="item.ctaBtnLabel"
          />
        </div>
      </ClientOnly>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'V2OrganismHomeVerticalSection'
})

defineProps({
  badgeTitle: {
    type: String,
    default: ''
  },

  title: {
    type: String,
    default: ''
  },

  description: {
    type: String,
    default: ''
  },

  list: {
    type: Array,
    default: () => []
  }
})
</script>
